import CustomerManagement from "./pages/CRM/CustomerManagement";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage'; // This is the general login page, not for /order/login
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import POSTrungThu from './pages/POSTrungThu';
import CartPage from './pages/CartPage';
import PromotionPage from './pages/PromotionPage';
import UuDaiCT from './pages/UuDaiCT';
import OrderPage from './pages/OrderPage';
import OrderLoginPage from './pages/OrderLoginPage'; // Import the new OrderLoginPage
import Dashboard from './pages/admin/dashboard';
import Dashboard_KTT from './pages/admin/dashboard_KTT';
import SoNganHang from './pages/KTT/SoNganHang';
import NhapHang from './pages/NhapHang';
import KiemTraNhapHang from './pages/KiemTraNhapHang';
import KTXacNhanPhieu from './pages/KTXacNhanPhieu';
import PhieuNhap from './pages/PhieuNhap';
import NewPhieuNhap from './pages/NewPhieuNhap';
import QuanLyKho from './pages/admin/QuanLyKho';
import QuanLySanPham from './pages/admin/QuanLySanPham';
import Docs from './pages/Docs';
import Admin from './pages/admin/Admin';
import ManageShift from './pages/admin/ManageShift';
import UpdateIP from './pages/admin/UpdateIP';
import UpdateQR from './pages/admin/UpdateQR';
import UpdateRounding from './pages/admin/UpdateRounding';
import StoreInfo from './pages/admin/StoreInfo';
import KiemKe from './pages/KiemKe';
import KHNgay from './pages/admin/KHNgay';
import DinhMucDinhLuong from './pages/DinhMucDinhLuong';
import QuanLyDinhMuc from './pages/QuanLyDinhMuc';
import ManageProduct from './pages/ManageProduct';
import DuLieuCa from './pages/admin/DuLieuCa'
import NhapHangAdmin from './pages/admin/NhapHangAdmin';
import DieuChuyen from './components/DieuChuyen/DieuChuyen';
import ConfirmDieuChuyen from './components/DieuChuyen/ConfirmDieuChuyen';
import ListDieuChuyen from './components/DieuChuyen/ListDieuChuyen';
import GioChamCong from './components/ChamCong/GioChamCong';
import PhieuNhapTT from './components/DieuPhoiTrungThu/PhieuNhapTT';
import NhapHangTT from './components/DieuPhoiTrungThu/NhapHangTT';
import NewPhieuNhapTT from './components/DieuPhoiTrungThu/NewPhieuNhapTT';
import ThongKeBanhTrungThu from './pages/admin/ThongKeBanhTrungThu'
import NewDieuChuyenTT from './components/DieuChuyenTT/NewDieuChuyenTT';
import DSTrungThu from './components/DoanhSoTrungThu/DSTrungThuu';
import LoginTT from './pages/LoginTT';
import LogOut from './pages/LogOut';
import PhieuDat from './components/PhieuDatTT/PhieuDat';
import OfficeCompetitionPage from './pages/admin/OfficeCompetitionPage';
import ImportDataKHPB from './components/KHPBTT/importDataKHPB';
import ChartKHPBTT from './components/KHPBTT/ChartKHPBTT';
import BanhDatTT from './components/PhieuDatTT/BanhDatTT';
import BanhBan from './components/PhieuDatTT/BanhBan';
import DashboarDataNew from './components/KHPBTT/DashboarDataNew';
import SetKPITheoMua from './components/KHPBTT/SetKPITheoMua';
import UpdateKpiPerDay from './components/KHPBTT/updateKpiPerDay';
import KPIPerDayChart from './components/KHPBTT/KPIPerDayChart';
import DashboardDataBkem from './components/BanhKemDashboard/DashboardBkem';
import DashboardBkemCustomByMockData from './components/BanhKemDashboard/DashboardBkemCustomByMockData';

import CapybaraFundManager from './components/Another/CapybaraFundManager';

import PhieuNhapNL from './components/DieuPhoiNguyenLieu/PhieuNhapNL';
import NewPhieuNhapNL from './components/DieuPhoiNguyenLieu/NewPhieuNhapNL';
import NhapHangNL from './components/DieuPhoiNguyenLieu/NhapHangNL';

import NhapHangBM from './components/DieuPhoiBanhMi/NhapHangBM';
import NewPhieuNhapBM  from './components/DieuPhoiBanhMi/NewPhieuNhapBM';
import PhieuNhapBM  from './components/DieuPhoiBanhMi/PhieuNhapBM';

import QuyenSD from './pages/admin/QuyenSD';
import ImportDiemCV from './pages/admin/ImportDiemCV';

import XuatExcelHoaDon from './pages/XuatExcelHoaDon';
import XuatExcelHoaDonExcel from './pages/XuatExcelHoaDonExcel';

import UpdateSchedule from './pages/admin/ScheduleUpdate';
import CheckVoucher from './pages/CRM/CheckVoucher';
import VoucherManagement from './pages/CRM/VoucherAdministration';
import CustomerPoints from './pages/CRM/CustomerPoints';
import CustomerVouchers from './pages/CRM/CustomerVouchers';
import PromotionManagement from './pages/CRM/PromotionManagement';
import CustomerLookupLinks from './pages/CRM/CustomerLookupLinks';
import VoucherUsedHistory from './pages/CRM/VoucherUsedHistory';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import BonpasDasboard from './components/BanhKemDashboard/BonpasDasboard';
serviceWorkerRegistration.register();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LogOut />} />
        <Route path="/login" element={<OrderLoginPage />} /> {/* General login */}
        <Route path="/logOut" element={<LogOut />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/promotions/:id" element={<PromotionPage />} />
        <Route path="/uu-dai-ct" element={<UuDaiCT />} />
        <Route path="/admin/permissions" element={<QuyenSD />} />
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/dashboard-ktt" element={<Dashboard_KTT />} />
        <Route path="/so-ngan-hang" element={<SoNganHang />} />

        <Route path="/admin/manage-shift" element={<ManageShift />} />
        <Route path="/admin/update-ip" element={<UpdateIP />} />
        <Route path="/admin/update-qr-code" element={<UpdateQR />} />
        <Route path="/admin/update-amount-rounding" element={<UpdateRounding />} />
        <Route path="/admin/store-info" element={<StoreInfo />} />
        <Route path="/kh-ngay" element={<KHNgay />} />
        <Route path="/admin/nhap-hang" element={<NhapHangAdmin />} />
        <Route path="/kiem-ke" element={<KiemKe />} />
        <Route path="/kiem-ke/:id" element={<KiemKe />} />
        <Route path="/kiem-ke/:id/:action" element={<KiemKe />} />
        <Route path="/manage-product" element={<ManageProduct />} />
        <Route path="/dieu-chuyen" element={<DieuChuyen />} />
        <Route path="/confirm-dieu-chuyen" element={<ConfirmDieuChuyen />} />
        <Route path="/ListDieuChuyen" element={<ListDieuChuyen />} />

        {/* Order specific routes */}
        <Route path="/order/login" element={<OrderLoginPage />} /> {/* New route for order login */}
        <Route path="/order/:storeName" element={<OrderPage />} />
        <Route path="/order" element={<Navigate to="/order/login" replace />} />
        <Route path="/pos-trung-thu/:storeName" element={<POSTrungThu />} />
        <Route path="/postrungthu/:storeName" element={<POSTrungThu />} />
        <Route path="/pos-trung-thu" element={<Navigate to="/order/login" replace />} />
        <Route path="/postrungthu" element={<Navigate to="/order/login" replace />} />

        {/* Nhap hang routes */}
        <Route path="/nhap-hang" element={<NhapHang />} />
        <Route path="/phieu-nhap/:id" element={<PhieuNhap />} />
        <Route path="/kiemtranhaphang" element={<KiemTraNhapHang />} />
        <Route path="/xacnhanphieu" element={<KTXacNhanPhieu />} />
        <Route path="/newphieunhap" element={<NewPhieuNhap />} />
        <Route path="/newphieunhap/:id" element={<NewPhieuNhap />} />
        <Route path="/newphieunhap/:id/:action" element={<NewPhieuNhap />} />
        <Route path="/thongkett" element={<ThongKeBanhTrungThu />} />

        {/* Legacy routes for backward compatibility */}
        <Route path="/nhaphang" element={<Navigate to="/nhap-hang" replace />} />
        <Route path="/phieunhap" element={<Navigate to="/nhap-hang" replace />} />

        {/* Quan ly routes */}
        <Route path="/quanlykho" element={<QuanLyKho />} />
        <Route path="/admin/DuLieuCa" element={<DuLieuCa />} />
        <Route path="/admin/manage-product" element={<QuanLySanPham />} />
        <Route path="/dinh-muc-dinh-luong" element={<DinhMucDinhLuong />} />
        <Route path="/quan-ly-dinh-muc" element={<QuanLyDinhMuc />} />

        {/* Docs routes */}
        <Route path="/docs" element={<Docs />} />
        {/* Fallback route */}
        <Route path="/admin/tax-invoice-reconciliation" element={<Admin initialComponent="tax-invoice-reconciliation" />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/*" element={<Admin />} />

        {/* Cham cong */}
        <Route path="/gio-cham-cong" element={<GioChamCong />} />

        {/* NhapHangTrungThu */}
        <Route path="/phieunhaptt/:id" element={<PhieuNhapTT />} />
        <Route path="/nhaphangtt" element={<NhapHangTT />} />
        <Route path="/newphieunhaptt" element={<NewPhieuNhapTT />} />
        <Route path="/newphieunhaptt/:id/:action" element={<NewPhieuNhapTT />} />
        <Route path="/LoginTT" element={<LoginTT />} />

        {/* Dieu Chuyen trung thu */}
        <Route path="/newdieuchuyentt" element={<NewDieuChuyenTT />} />
        {/* DS trung thu */}
        <Route path="/TKTT" element={<DSTrungThu />} />

        {/* PhieuDatTrungThu */}\
        <Route path="/banh-dat-trung-thu" element={<BanhDatTT />} />
        <Route path="/banh-dat-trung-thu/:id" element={<BanhDatTT />} />
        <Route path="/banh-dat-trung-thu/:id/:action" element={<BanhDatTT />} />
        <Route path="/phieu-dat-trung-thu" element={<PhieuDat />} />
        <Route path="/phieu-dat-trung-thu/:id" element={<PhieuDat />} />
        <Route path="/phieu-dat-trung-thu/:id/:action" element={<PhieuDat />} />
        <Route
          path="/bieu-do-trung-thu"
          element={<OfficeCompetitionPage showNavbarTrungThu />}
        />
        <Route path="/import-khpb" element={<ImportDataKHPB />} />
        <Route path="/chart-khpb" element={<ChartKHPBTT />} />
        <Route path="/banh-ban" element={<BanhBan />} />
        <Route path="/banh-ban/:id" element={<BanhBan />} />
        <Route path="/banh-ban/:id/:action" element={<BanhBan />} />
        <Route path="/dashboard-data" element={<DashboarDataNew />} />
        <Route path="/set-kpi-theo-mua" element={<SetKPITheoMua />} />
        <Route path="/updateKpiPerDay" element={<UpdateKpiPerDay />} />
        <Route path="/kpi-per-day-chart" element={<KPIPerDayChart />} />
        <Route path="/dashboardbkem_backup" element={<DashboardDataBkem />} />
        <Route path="/dashboardbkem" element={<DashboardBkemCustomByMockData />} />
        <Route path="/Capybara" element={<CapybaraFundManager />} />

        {/* Dieu Phoi nguyen liiu */}
        <Route path="/phieu-nhap-nguyen-lieu" element={<PhieuNhapNL />} />
        <Route path="/phieu-nhap-nguyen-lieu/:id" element={<PhieuNhapNL />} />
        <Route path="/new-phieu-nhap-nguyen-lieu" element={<NewPhieuNhapNL />} />
        <Route path="/new-phieu-nhap-nguyen-lieu/:id/:action" element={<NewPhieuNhapNL />} />
        <Route path="/NhapHangNL" element={<NhapHangNL />} />

                {/* Dieu Phoi banh mi khong nhan */}
        <Route path="/phieu-nhap-banh-mi" element={<PhieuNhapBM />} />
        <Route path="/phieu-nhap-banh-mi/:id" element={<PhieuNhapBM />} />
        <Route path="/new-phieu-nhap-banh-mi" element={<NewPhieuNhapBM />} />
        <Route path="/new-phieu-nhap-banh-mi/:id/:action" element={<NewPhieuNhapBM />} />
        <Route path="/NhapHangBM" element={<NhapHangBM />} />
        <Route path="/import-diem-cv" element={<ImportDiemCV />} />
        <Route path="/xuat-excel-hoa-don" element={<XuatExcelHoaDon />} />
        <Route path="/xuat-excel-hoa-don-all" element={<XuatExcelHoaDonExcel />}/>

        <Route path="/admin/schedule-update" element={<UpdateSchedule />} />
        <Route path="/check-voucher" element={<CheckVoucher />} />
        <Route path="/customer-management" element={<CustomerManagement />} />
        <Route path="/voucher-management" element={<VoucherManagement />} />
        <Route path="/customer-points" element={<CustomerPoints />} />
        <Route path="/customer-vouchers" element={<CustomerVouchers />} />
        <Route path="/customer-vouchers/manage" element={<CustomerVouchers manage />} />
        <Route path="/customer-lookup-links" element={<CustomerLookupLinks />} />
        <Route path="/promotion-management" element={<PromotionManagement />} />
        <Route path="/voucher-used-history" element={<VoucherUsedHistory />} />

        <Route path="/dashboard-bonpas" element={<BonpasDasboard />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
